import RedeemHistory from './RedeemHistory';

export default RedeemHistory;
